import { CalEventFieldType } from '../constants/cal-event-field-type.js';
export const AUTHORABLE_FIELD_TYPES = [
    CalEventFieldType.TEXT,
    CalEventFieldType.NUMBER,
    CalEventFieldType.DATE,
    CalEventFieldType.SELECT,
    CalEventFieldType.ENTITY_REF,
    CalEventFieldType.PER_PRODUCT_NUMBER,
];
//# sourceMappingURL=authorable-field-types.js.map